<template>
  <div>
    <!-- Table Container Card -->
    <b-card no-body class="mb-0">
      <template #header>
        <multi-filter
          :filter="filter"
          @filter-change="setFilter"
          :extraStatus="extraStatus"
        ></multi-filter>
      </template>
      <table-spinner :loading="loading"></table-spinner>
      <total-income v-if="total.data" :total="total.data" />
      <transaction-list
        v-if="!loading"
        :data="data"
        :prevField="prevField"
        @onSort="changePage"
        :filter="filter"
      >
      </transaction-list>
      <template #footer>
        <pagination
          :meta-data="meta"
          @change-page="changePage({ page: $event })"
          @change-per-page="changePerPage({ per_page: $event })"
        >
        </pagination>
      </template>
    </b-card>
  </div>
</template>

<script>
import { BCard } from "bootstrap-vue";
import TransactionList from "@/layouts/components/transaction/TransactionList.vue";
import { mapActions } from "vuex";
import Pagination from "@/layouts/components/XmlTvPagination.vue";
import debounce from "lodash.debounce";
import TableSpinner from "@/layouts/components/TableSpinner.vue";
import MultiFilter from "@/layouts/components/PaymentFilter.vue";
import { getFirstDayOfMonth } from "@/services/utils/util";
import TotalIncome from "@/layouts/components/TotalIncome.vue";
export default {
  components: {
    BCard,
    Pagination,
    TransactionList,
    TableSpinner,
    MultiFilter,
    TotalIncome,
  },
  data() {
    return {
      loading: false,
      prevField: [{ key: "payment_id", label: "Payment ID" }],
      extraStatus: ["unclaimed"],
    };
  },
  computed: {
    filter() {
      return {
        ...this.$route.query,
        start_date: this.$route.query?.start_date ?? getFirstDayOfMonth(),
        end_date: this.$route.query?.end_date ?? new Date().toJSON(),
        page: this.$route.query?.page ?? 1,
        per_page: this.$route.query?.per_page ?? 10,
        sort_by: this.$route.query?.sort_by ?? "payment_id",
        order_by: this.$route.query?.order_by ?? "asc",
      };
    },
    data() {
      return this.$store.getters["adminPaymentList/getPaymentListData"];
    },
    meta() {
      return this.$store.getters["adminPaymentList/getPaymentListMeta"];
    },
    total() {
      return this.$store.getters["adminPaymentList/getPaymentTotalIncomeData"];
    },
  },
  mounted() {
    this.getPayments({ ...this.filter }).catch(console.error);
    this.getPaymentTotalIncome({ ...this.filter }).catch(console.error);
  },
  methods: {
    ...mapActions({
      getPayments: "adminPaymentList/getPayments",
      getPaymentTotalIncome: "adminPaymentList/getPaymentTotalIncome",
    }),
    changePage(filter = {}) {
      this.$router.replace({ query: { ...this.filter, ...filter } });
      this.onRefreshPage();
    },
    changePerPage(filter = {}) {
      this.filter.page = 1;
      this.$router.replace({ query: { ...this.filter, ...filter } });
      this.onRefreshPage();
    },
    setFilter(filter = {}) {
      this.filter.page = 1;
      this.$router.replace({ query: { ...this.filter, ...filter } });

      if (filter.search !== undefined) {
        if (filter.search?.length === 0) {
          this.$router.replace({
            query: { ...this.filter, search: undefined },
          });
        }
      }

      this.onRefreshPage();
      this.onRefreshIncome();
    },
    onRefreshPage: debounce(async function () {
      this.loading = true;
      try {
        await this.getPayments(this.filter);
      } finally {
        this.loading = false;
      }
    }, 300),
    onRefreshIncome: debounce(function () {
      return this.getPaymentTotalIncome(this.filter);
    }, 300),
  },
};
</script>

<style></style>
